import mahima from "../assets/images/mahima.jpeg";
import tapsi from "../assets/images/tapsi.jpeg";
import sumit from "../assets/images/sumit.jpeg";
import rishika from "../assets/images/rishika.jpeg";

const testimonialsObjectList = [
  {
    img: mahima,
    description:
      "I had no clue whether I should go for Science or Commerce. RisoApp’s career assessment helped me understand my strengths, and the counsellor guided me with real clarity. I finally feel confident about my decision!",
    designation: "Mahima Baria, Navi Mumbai",
  },
  {
    img: tapsi,
    description:
      "I was stuck in a course I didn’t enjoy. RisoApp helped me explore better-aligned options and short-term skills to build my profile. I wish I had this guidance earlier!",
    designation: "Tapsi Bahinipati, Berhampur",
  },
  {
    img: sumit,
    description:
      "After graduation, I was lost between job boards and advice from random people. RisoApp gave me a clear roadmap with job options that matched my skills. I even got a referral from the RisoHire section!",
    designation: "Sumit Patel, Patna",
  },
  {
    img: rishika,
    description:
      "RisoApp has helped me scale my counselling sessions with better data and insights. The AI recommendations save me time and the dashboard is simple to use. It's truly built for modern guidance.",
    designation: "Rishika Mishra, Certified Career Counsellor, Delhi NCR",
  },
];

export default testimonialsObjectList;
